import { Currency } from './../../../../../../../shared/src/lib/_enums/currency.enum';
import { shouldBeGreaterThanZero } from './../../../../../../../shared/src/lib/validators/shouldBeGreaterThanZero';
import { formMethods } from '../../../../../../../shared/src/lib/utils/form-control-methods';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  NipPaymentRequest,
  PaymentGateway,
  Platform,
} from '../../providers/payment-interface';
import { NipPaymentStateService } from '../../states/nip.state';
import { ConsoleRouterService } from '@console/shared';
import { PRODUCT_TYPE_ENUM } from '@console/shared/_enums';

@Component({
  selector: 'kt-user-accounts-fund',
  templateUrl: './fund.component.html',
})
export class NipFundComponent implements OnInit, OnDestroy {
  @Input() userId: string;
  fundForm: FormGroup;
  public formMethods;
  currencyList = [
    {
      description: '--Select--',
      value: '',
    },
    {
      description: 'Naira',
      value: Currency.NGN,
    },
    {
      description: 'Dollar',
      value: Currency.USD,
    },
  ];

  constructor(
    private fb: FormBuilder,
    public nip: NipPaymentStateService,
    private router: ConsoleRouterService
  ) {}

  createForm(): void {
    this.fundForm = this.fb.group({
      amount: [0, [Validators.required, shouldBeGreaterThanZero]],
      description: ['', Validators.required],
      currency: ['NGN', Validators.required],
    });

    this.formMethods = formMethods(this.fundForm);

    if (this.router.product === PRODUCT_TYPE_ENUM.advisory) {
      this.currencyList = [
        {
          description: 'Dollar',
          value: Currency.USD,
        },
      ];

      this.fundForm.get('currency').setValue(Currency.USD);
      this.fundForm.get('currency').updateValueAndValidity();

      return;
    }
  }

  generateNipRef(
    form: Omit<NipPaymentRequest, 'transactionReference' | 'userId'>
  ): void {
    this.nip.generateReference({
      ...form,
      processor: PaymentGateway.NIP,
      source: Platform.WEB,
      userId: this.userId,
    });
  }

  createNip(
    form: Omit<NipPaymentRequest, 'transactionReference' | 'userId'>
  ): void {
    this.nip.payWithNip({
      ...form,
      userId: this.userId,
    });
  }

  onEnterReference($event: MouseEvent): void {
    if (this.fundForm.valid) {
      $event.stopPropagation();
      return;
    }

    setTimeout(() => {
      this.fundForm.markAllAsTouched();
    }, 1000);
  }

  ngOnInit(): void {
    this.createForm();
  }

  ngOnDestroy(): void {
    this.nip.resetState();
  }
}
